import * as React from "react";
import { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgBuyers = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32" width="1em" height="1em" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<clipPath id="a"><path d="M0 0h32v32H0z" /></clipPath><g clipPath="url(#a)"><path fill="currentColor" fillRule="evenodd" d="M29.54 32c1.333 0 2.46-1.127 2.46-2.46 0-.65-.272-1.3-.717-1.744l-6.6-6.6c1.574-2.221 2.394-4.92 2.394-7.658A13.527 13.527 0 0 0 13.54 0 13.526 13.526 0 0 0 0 13.538a13.526 13.526 0 0 0 13.538 13.54c2.736 0 5.437-.82 7.659-2.394l6.599 6.599c.479.445 1.093.717 1.743.717zM8.3 8.56c3.36-3.36 7.559-2.52 10.918-1.68-4.102-4.36-10.514-1.304-12.5.678-1.983 1.984-3.681 7.817.582 12.08-1.68-3.36-1.835-8.244 1-11.079z" clipRule="evenodd" /></g></svg>;
export default SvgBuyers;